import React from "react";
import Marquee from "react-fast-marquee";

function MarqueeSection() {
  const ClientData = [
    {
      name: "banner1",
      url: "/images/marquee/01.png",
    },
    {
      name: "banner2",
      url: "/images/marquee/02.png",
    },
    {
      name: "banner3",
      url: "/images/marquee/03.png",
    },
    {
      name: "banner4",
      url: "/images/marquee/04.webp",
    },
    {
      name: "banner5",
      url: "/images/marquee/05.png",
    },
    {
      name: "banner6",
      url: "/images/marquee/06.png",
    },
    {
      name: "banner7",
      url: "/images/marquee/07.png",
    },
  ];

  return (
    <div className="bg-[#f1f5f9] py-5 min-[480px]:py-10">
      <div className="container mx-auto">
        <h2 className="poppins_regular text-3xl sm:text-5xl text-center mt-5 mb-10">
          {" "}
          Prestigious Clients
        </h2>
        <Marquee
          autoFill
          pauseOnHover
          gradient
          gradientWidth="200px"
          gradientColor="#f1f5f9"
        >
          {ClientData?.map((client) => (
            <img
              src={client.url}
              alt={client.name}
              className="mr-20 sm:mr-40 w-20 min-[480px]:w-28"
            />
          ))}
        </Marquee>
      </div>
    </div>
  );
}

export default MarqueeSection;
